import React from 'react';
import { Box, makeStyles, ListItem, List } from '@material-ui/core';
import { Link, NavLink } from 'react-router-dom';
import Routes from '../Utils/routes.json';
import HomeIcon from '../../../Assets/icons/Home.png';
import FileUpload from '../../../Assets/upload_icon.svg';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('md')]: {
      paddingTop: 70,
    },
  },
  link: {
    textDecoration: 'none',
  },

  listItem: {
    padding: '12px 20px',
    marginLeft: 4,
    '&:hover': {
      // backgroundColor: theme.palette.KenColors.sideNavItemHoverBackground,
    },
    '&.Mui-selected': {
      // backgroundColor: "turquoise",
      // fontWeight: 600,
    },
  },
  active: {
    '& $listItem': {
      borderLeft: `4px solid ${theme.palette.KenColors.primary}`,
      marginLeft: 0,
    },
    '&.Mui-selected': {
      // backgroundColor: theme.palette.KenColors.sideNavItemActiveBackground,
      // fontWeight: 600,
      '&:hover': {
        // backgroundColor: theme.palette.KenColors.sideNavItemActiveBackground,
        // color: 'white',
      },
    },
  },
  heading: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.KenColors.neutral400,
    marginLeft: 8,
  },
  sideNavIcon: {
    width: 24,
    height: 24,
  },
}));

export default function SideNavigation(props) {
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const { t } = useTranslation();

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  return (
    <Box className={classes.root}>
      <List>
        <NavLink
          className={classes.link}
          to={`/app/${Routes.home}`}
          activeClassName={classes.active}
        >
          <ListItem
            classes={{
              root: classes.listItem,
              selected: classes.active,
            }}
            button
            key="home"
          >
            <span>
              <img src={HomeIcon} alt="home" className={classes.sideNavIcon} />
            </span>
            <span className={classes.heading}>{t('translations:home')}</span>
          </ListItem>
        </NavLink>

        <NavLink
          className={classes.link}
          to={`/app/${Routes.fileUpload}`}
          activeClassName={classes.active}
        >
          <ListItem
            classes={{
              root: classes.listItem,
              selected: classes.active,
            }}
            button
            key="fileUpload"
          >
            <span>
              <img
                src={FileUpload}
                alt="file load"
                className={classes.sideNavIcon}
              />
            </span>
            <span className={classes.heading}>
              {t('translations:file_load')}
            </span>
          </ListItem>
        </NavLink>
      </List>
    </Box>
  );
}
